import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";
import type { Dispatch, SetStateAction } from "react";

import ModalConversationImageSettings from "@/pages/Chat/components/ModalConversationImageSettings";

type CapabilityModalConversationImageSettingsProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export default function CapabilityModalConversationImageSettings({ isOpen, setIsOpen }: CapabilityModalConversationImageSettingsProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <CapabilityGate capability={SubCapabilityKey.ChatImageImageGenerationSettings}>
      <ModalConversationImageSettings isOpen={isOpen} setIsOpen={setIsOpen} />
    </CapabilityGate>
  );
}
